import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=360a4982&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=360a4982&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a4982",
  null
  
)

export default component.exports